import { render, staticRenderFns } from "./GalleryPhotoswipe.vue?vue&type=template&id=7598a8b0&scoped=true&"
import script from "./GalleryPhotoswipe.vue?vue&type=script&lang=js&"
export * from "./GalleryPhotoswipe.vue?vue&type=script&lang=js&"
import style0 from "./GalleryPhotoswipe.vue?vue&type=style&index=0&id=7598a8b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7598a8b0",
  null
  
)

export default component.exports